import { format } from 'date-fns';
import { AnimalGroup, IndividualAnimal } from '../types/animal';

export const formatDate = (dateString: string): string => {
  if (!dateString) return 'N/A';
  try {
    return format(new Date(dateString), 'MMM d, yyyy');
  } catch (e) {
    return dateString;
  }
};

export const calculateAge = (birthDate: string): string => {
  if (!birthDate) return 'Unknown';
  const birth = new Date(birthDate);
  const now = new Date();
  const diffTime = Math.abs(now.getTime() - birth.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays < 30) return `${diffDays} days`;
  if (diffDays < 365) return `${Math.floor(diffDays / 30)} months`;
  return `${Math.floor(diffDays / 365)} years`;
};

export const getParentName = (parentId: string | undefined, animalGroups: AnimalGroup[]) => {
  if (!parentId) return 'Unknown';
  for (const group of animalGroups) {
    const parent = group.individuals.find(a => a.id === parentId);
    if (parent) return parent.name;
  }
  return 'Unknown';
};

export const getOffspring = (animalId: string, animalGroups: AnimalGroup[]): IndividualAnimal[] => {
  const offspring: IndividualAnimal[] = [];
  animalGroups.forEach(group => {
    group.individuals.forEach(animal => {
      if (animal.parentMaleId === animalId || animal.parentFemaleId === animalId) {
        offspring.push(animal);
      }
    });
  });
  return offspring;
};
